import useDeviceDetect from './useDeviceDetect'

export default useDeviceDetect
